// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"70":"28849f831345bbc383ca","616":"3aa93036f334276e8fc2"}[chunkId] + ".min.js";
};